'use strict';

var styled = require('styled-components');

function _interopDefaultCompat (e) { return e && typeof e === 'object' && 'default' in e ? e : { default: e }; }

var styled__default = /*#__PURE__*/_interopDefaultCompat(styled);

/**
 * BADGES CONSTANTS
 */
const badgeSize = {
    default: 's',
    small: 's',
    medium: 'm',
    large: 'l',
};
const sizesMapping = (theme) => ({
    [badgeSize.small]: theme.designTokens.badgeHeightSmall,
    [badgeSize.medium]: theme.designTokens.badgeHeightMedium,
    [badgeSize.large]: theme.designTokens.badgeHeightLarge,
});
const paddingsMapping = (theme) => ({
    [badgeSize.small]: `0 ${theme.designTokens.badgePaddingSmall}`,
    [badgeSize.medium]: `0 ${theme.designTokens.badgePaddingMedium}`,
    [badgeSize.large]: `0 ${theme.designTokens.badgePaddingLarge}`,
});
const radiusesMapping = (theme) => ({
    [badgeSize.small]: theme.designTokens.badgeRadiusSmall,
    [badgeSize.medium]: theme.designTokens.badgeRadiusMedium,
    [badgeSize.large]: theme.designTokens.badgeRadiusLarge,
});
/**
 * CSS FUNCTIONS
 */
const isChildrenSmallText = (children) => typeof children === 'string' && children.length < 2;
const getBadgeSize = ({ size = badgeSize.default, theme }) => sizesMapping(theme)[size];
const getBadgeRadius = ({ size = badgeSize.default, theme, children }) => isChildrenSmallText(children) ? '100%' : radiusesMapping(theme)[size];
const getBadgePadding = ({ size = badgeSize.default, children, theme }) => isChildrenSmallText(children) ? '0px' : paddingsMapping(theme)[size];
const getBadgeBackground = ({ lighter, theme }) => lighter ? theme.designTokens.badgeLighterBackgroundColor : theme.designTokens.badgeDefaultBackgroundColor;
const getBadgeColor = ({ lighter, theme }) => lighter ? theme.designTokens.badgeLighterTextColor : theme.designTokens.badgeDefaultTextColor;
/**
 * Badge Component
 */
const Badge = styled__default.default.div `
  align-items: center;
  display: inline-flex;
  justify-content: center;
  position: relative;

  min-height: ${getBadgeSize};
  min-width: ${getBadgeSize};
  margin: 0;
  padding: ${getBadgePadding};

  background: ${getBadgeBackground};

  border: none;
  border-radius: ${getBadgeRadius};

  color: ${getBadgeColor};
  font: inherit;
  font-family: ${({ theme }) => theme.designTokens.badgeFontFamily};
  font-size: ${({ theme }) => theme.designTokens.badgeFontSize};
  font-weight: ${({ theme }) => theme.designTokens.badgeFontWeight};
  line-height: ${({ theme }) => theme.designTokens.badgeFontLineHeight};
  letter-spacing: 0;
  text-align: center;
`;
Badge.defaultProps = {
    lighter: false,
    size: 's',
};

exports.Badge = Badge;
exports.badgeSize = badgeSize;
exports.getBadgeBackground = getBadgeBackground;
exports.getBadgeColor = getBadgeColor;
exports.getBadgePadding = getBadgePadding;
exports.getBadgeRadius = getBadgeRadius;
exports.getBadgeSize = getBadgeSize;
exports.isChildrenSmallText = isChildrenSmallText;
exports.paddingsMapping = paddingsMapping;
exports.radiusesMapping = radiusesMapping;
exports.sizesMapping = sizesMapping;
//# sourceMappingURL=component.js.map
